import { ConstraintPrematureWellShutdownDetailBase } from './base/constraint-premature-well-shutdown-detail-base';

export class ConstraintPrematureWellShutdownDetail extends ConstraintPrematureWellShutdownDetailBase { }